module.exports = __webpack_public_path__ + "img/project-hydrogreen.f6be93ef.png";